//import Cities from './Cities'
import RolesType from './RolesType'

export {RolesType}


// WEBPACK FOOTER //
// ./src/modules/Roles/Components/DropDowns/index.js